// Version 0

// // makeStyles.ts
// import { css } from '@emotion/css'
// import { useMemo } from 'react'
// import { useTheme, type Theme } from '@mui/material/styles'

// type Styles<TProps, TTheme> = Record<
//   string,
//   | Record<string, string | number | object>
//   | ((props: TProps, theme: TTheme) => Record<string, string | number | object>)
// >

// export function makeStyles<TProps = any>(
//   styles: (theme: Theme) => Styles<TProps, Theme>
// ) {
//   return (props?: TProps) => {
//     const theme = useTheme()

//     return useMemo(() => {
//       const styleObj = styles(theme)

//       const classes: Record<string, string> = {}
//       Object.keys(styleObj).forEach((key) => {
//         const val = styleObj[key]
//         const resolved = typeof val === 'function' ? val(props!, theme) : val
//         classes[key] = css(resolved as any)
//       })

//       return classes
//     }, [theme, props])
//   }
// }

// Version 0

// Version 1

// makeStyles.ts
// import { css } from '@emotion/css'
// import { useMemo, type CSSProperties } from 'react'
// import { useTheme, type Theme } from '@mui/material/styles'

// type StyleObject = CSSProperties & Record<string, any> // allow nested selectors

// type Styles<TProps, TTheme> = Record<
//   string,
//   StyleObject | ((props: TProps, theme: TTheme) => StyleObject)
// >

// export function makeStyles<TProps = any>(
//   styles: (theme: Theme) => Styles<TProps, Theme>
// ) {
//   return (props?: TProps) => {
//     const theme = useTheme()

//     return useMemo(() => {
//       const styleObj = styles(theme)

//       const classes: Record<string, string> = {}
//       Object.keys(styleObj).forEach((key) => {
//         const val = styleObj[key]
//         const resolved = typeof val === 'function' ? val(props!, theme) : val
//         classes[key] = css(resolved as any)
//       })

//       return classes
//     }, [theme, props])
//   }
// }

// import { css } from '@emotion/css'
// import { useMemo, type CSSProperties } from 'react'
// import { useTheme, type Theme } from '@mui/material/styles'

// type StyleObject = CSSProperties & Record<string, any> // allow nested selectors

// type Styles<TProps, TTheme> = Record<
//   string,
//   StyleObject | ((props: TProps, theme: TTheme) => StyleObject)
// >

// export function makeStyles<TProps = any>(
//   styles: (theme: Theme) => Styles<TProps, Theme>
// ) {
//   return (props?: TProps) => {
//     const theme = useTheme()

//     return useMemo(() => {
//       const styleObj = styles(theme)

//       const classes: Record<string, string> = {}
//       for (const key in styleObj) {
//         const val = styleObj[key]
//         const resolved =
//           typeof val === 'function' ? val(props ?? ({} as TProps), theme) : val
//         classes[key] = css(resolved)
//       }

//       return classes
//     }, [theme, props])
//   }
// }

// Version 1

// Version 2

// import { css } from '@emotion/css'
// import { useMemo } from 'react'
// import { useTheme, type Theme } from '@mui/material/styles'

// type StyleObject = Record<string, any> // allow nested selectors

// type Styles<TProps, TTheme> = Record<
//   string,
//   StyleObject | ((props: TProps, theme: TTheme) => StyleObject)
// >

// export function makeStyles<TProps = any>(
//   styles: (theme: Theme) => Styles<TProps, Theme>
// ) {
//   return (props?: TProps) => {
//     const theme = useTheme()

//     return useMemo(() => {
//       const styleObj = styles(theme)

//       // First pass: resolve styles + generate placeholders
//       const raw: Record<string, StyleObject> = {}
//       for (const key in styleObj) {
//         const val = styleObj[key]
//         raw[key] =
//           typeof val === 'function' ? val(props ?? ({} as TProps), theme) : val
//       }

//       // Second pass: expand nested selectors like "& $child"
//       const expanded: Record<string, StyleObject> = {}
//       for (const key in raw) {
//         const style = { ...raw[key] }
//         for (const rule in style) {
//           if (rule.includes('$')) {
//             const replaced = rule.replace(/\$([a-zA-Z0-9_-]+)/g, (m, child) => {
//               return `.${child}` // placeholder, replaced after css()
//             })
//             style[replaced] = style[rule]
//             delete style[rule]
//           }
//         }
//         expanded[key] = style
//       }

//       // Third pass: generate emotion classes
//       const classes: Record<string, string> = {}
//       for (const key in expanded) {
//         classes[key] = css(expanded[key])
//       }

//       // Final pass: replace .child placeholders with actual class names
//       for (const key in classes) {
//         const cls = classes[key]
//         for (const k in expanded[key]) {
//           if (k.includes('.')) {
//             const fixed = k.replace(/\.(\w+)/g, (_, child) => {
//               return `.${classes[child]}`
//             })
//             ;(expanded[key] as any)[fixed] = expanded[key][k]
//             delete expanded[key][k]
//           }
//         }
//         classes[key] = css(expanded[key])
//       }

//       return classes
//     }, [theme, props])
//   }
// }

// Version 2

// Version 3

// import { css } from '@emotion/css'
// import { useMemo } from 'react'
// import { useTheme, type Theme } from '@mui/material/styles'

// type PlainObject = Record<string, any>
// type StyleObject = PlainObject // allow nested selectors, media queries, etc.
// type StyleEntry<TProps, TTheme> =
//   | StyleObject
//   | ((props: TProps, theme: TTheme) => StyleObject)

// type Styles<TProps, TTheme> = Record<string, StyleEntry<TProps, TTheme>>

// const isPlainObject = (v: any): v is PlainObject =>
//   v != null && typeof v === 'object' && !Array.isArray(v)

// // ✅ Works in Vite: true if dev mode
// const DEV =
//   typeof import.meta !== 'undefined' &&
//   import.meta.env &&
//   import.meta.env.DEV === true

// /** Walk an object recursively and call fn(key, value, parent) to possibly transform key/value. */
// function walkObject(
//   obj: StyleObject,
//   fn: (
//     key: string,
//     value: any,
//     parent: StyleObject
//   ) => { key: string; value: any } | null
// ): StyleObject {
//   const out: StyleObject = {}
//   for (const k of Object.keys(obj ?? {})) {
//     const v = obj[k]
//     const next = fn(k, v, obj)
//     if (next === null) continue // drop this key
//     const { key: nk, value: nv } = next
//     if (isPlainObject(nv)) {
//       out[nk] = walkObject(nv, fn)
//     } else {
//       out[nk] = nv
//     }
//   }
//   return out
// }

// /** Collect $ref names used in selector keys anywhere in the object. */
// function collectDollarRefs(style: StyleObject, bucket: Set<string>) {
//   const re = /\$([a-zA-Z0-9_-]+)/g
//   function visit(obj: StyleObject) {
//     for (const k of Object.keys(obj ?? {})) {
//       const v = obj[k]
//       let m: RegExpExecArray | null
//       while ((m = re.exec(k))) bucket.add(m[1])
//       if (isPlainObject(v)) visit(v)
//     }
//   }
//   visit(style)
// }

// /** Replace $refs in keys using a resolver; if resolver returns undefined -> drop the rule. */
// function replaceDollarRefs(
//   style: StyleObject,
//   resolver: (ref: string) => string | undefined
// ): StyleObject {
//   const re = /\$([a-zA-Z0-9_-]+)/g
//   return walkObject(style, (key, value) => {
//     if (!key.includes('$')) return { key, value }
//     let hadUnknown = false
//     const newKey = key.replace(re, (_m, ref) => {
//       const rep = resolver(ref)
//       if (!rep) {
//         hadUnknown = true
//         return '__DROP__' // temporary marker
//       }
//       return rep.startsWith('.') ? rep : `.${rep}`
//     })
//     if (hadUnknown || newKey.includes('__DROP__')) {
//       if (DEV)
//         console.warn('[makeStyles] Dropping selector with unknown $ref:', key)
//       return null
//     }
//     return { key: newKey, value }
//   })
// }

// /** Create classes in dependency order; handle cycles/missing refs robustly. */
// function compileStyles(
//   resolvedStyles: Record<string, StyleObject>
// ): Record<string, string> {
//   const keys = Object.keys(resolvedStyles)
//   const deps: Record<string, Set<string>> = {}
//   keys.forEach((k) => {
//     const s = resolvedStyles[k] ?? {}
//     const set = new Set<string>()
//     collectDollarRefs(s, set)
//     deps[k] = set
//   })

//   const classes: Record<string, string> = {}
//   const done = new Set<string>()

//   let progress = true
//   let iterations = 0
//   const maxIterations = keys.length * 2

//   while (progress && iterations++ < maxIterations) {
//     progress = false

//     for (const k of keys) {
//       if (done.has(k)) continue
//       const allDepsKnown = Array.from(deps[k]).every((d) => classes[d])

//       if (deps[k].size === 0) {
//         try {
//           classes[k] = css(resolvedStyles[k] || {})
//         } catch (e) {
//           if (DEV)
//             console.error('[makeStyles] Failed to compile style for', k, e)
//           classes[k] = css({})
//         }
//         done.add(k)
//         progress = true
//       } else if (allDepsKnown) {
//         const replaced = replaceDollarRefs(
//           resolvedStyles[k] || {},
//           (ref) => classes[ref]
//         )
//         try {
//           classes[k] = css(replaced)
//         } catch (e) {
//           if (DEV)
//             console.error(
//               '[makeStyles] Failed to compile (with $refs) for',
//               k,
//               e
//             )
//           classes[k] = css({})
//         }
//         done.add(k)
//         progress = true
//       }
//     }
//   }

//   for (const k of keys) {
//     if (done.has(k)) continue
//     const replaced = replaceDollarRefs(
//       resolvedStyles[k] || {},
//       (ref) => classes[ref]
//     )
//     try {
//       classes[k] = css(replaced)
//     } catch (e) {
//       if (DEV) console.error('[makeStyles] Fallback compile failed for', k, e)
//       classes[k] = css({})
//     }
//     done.add(k)
//   }

//   return classes
// }

// export function makeStyles<TProps = any>(
//   styles: (theme: Theme) => Styles<TProps, Theme>
// ) {
//   return (props?: TProps) => {
//     const theme = useTheme()

//     return useMemo(() => {
//       let styleMap: Styles<TProps, Theme>
//       try {
//         styleMap = styles(theme) || ({} as Styles<TProps, Theme>)
//       } catch (e) {
//         if (DEV) console.error('[makeStyles] styles(theme) threw:', e)
//         return {} as Record<string, string>
//       }

//       const resolved: Record<string, StyleObject> = {}
//       for (const key of Object.keys(styleMap)) {
//         const entry = styleMap[key]
//         try {
//           const style =
//             typeof entry === 'function'
//               ? (entry as any)(props ?? ({} as TProps), theme)
//               : entry
//           resolved[key] = isPlainObject(style) ? style : {}
//         } catch (e) {
//           if (DEV)
//             console.error(`[makeStyles] style "${key}" resolver threw:`, e)
//           resolved[key] = {}
//         }
//       }

//       try {
//         return compileStyles(resolved)
//       } catch (e) {
//         if (DEV) console.error('[makeStyles] compileStyles threw:', e)
//         const empty = css({})
//         const fallback: Record<string, string> = {}
//         for (const k of Object.keys(resolved)) fallback[k] = empty
//         return fallback
//       }
//     }, [theme, props])
//   }
// }

// Version 3

// Version 4

import { css } from '@emotion/css'
import { useMemo } from 'react'
import { useTheme, type Theme } from '@mui/material/styles'
import type { CSSObject } from '@emotion/react' // 👈 gives strong CSS typing

type PlainObject = CSSObject
type StyleObject = PlainObject
type StyleEntry<TProps, TTheme> =
  | StyleObject
  | ((props: TProps, theme: TTheme) => StyleObject)

type Styles<TProps, TTheme> = Record<string, StyleEntry<TProps, TTheme>>

const isPlainObject = (v: any): v is PlainObject =>
  v != null && typeof v === 'object' && !Array.isArray(v)

const DEV = import.meta?.env?.DEV === true

function walkObject(
  obj: StyleObject,
  fn: (
    key: string,
    value: any,
    parent: StyleObject
  ) => { key: string; value: any } | null
): StyleObject {
  const out: StyleObject = {}
  for (const k of Object.keys(obj ?? {})) {
    const v = obj[k]
    const next = fn(k, v, obj)
    if (next === null) continue
    const { key: nk, value: nv } = next
    if (isPlainObject(nv)) {
      out[nk] = walkObject(nv, fn)
    } else {
      out[nk] = nv
    }
  }
  return out
}

function collectDollarRefs(style: StyleObject, bucket: Set<string>) {
  const re = /\$([a-zA-Z0-9_-]+)/g
  function visit(obj: StyleObject) {
    for (const k of Object.keys(obj ?? {})) {
      const v = obj[k]
      let m: RegExpExecArray | null
      while ((m = re.exec(k))) bucket.add(m[1])
      if (isPlainObject(v)) visit(v)
    }
  }
  visit(style)
}

function replaceDollarRefs(
  style: StyleObject,
  resolver: (ref: string) => string | undefined
): StyleObject {
  const re = /\$([a-zA-Z0-9_-]+)/g
  return walkObject(style, (key, value) => {
    if (!key.includes('$')) return { key, value }
    let hadUnknown = false
    const newKey = key.replace(re, (_m, ref) => {
      const rep = resolver(ref)
      if (!rep) {
        hadUnknown = true
        return '__DROP__'
      }
      return rep.startsWith('.') ? rep : `.${rep}`
    })
    if (hadUnknown || newKey.includes('__DROP__')) {
      if (DEV)
        console.warn('[makeStyles] Dropping selector with unknown $ref:', key)
      return null
    }
    return { key: newKey, value }
  })
}

function compileStyles(
  resolvedStyles: Record<string, StyleObject>
): Record<string, string> {
  const keys = Object.keys(resolvedStyles)
  const deps: Record<string, Set<string>> = {}
  keys.forEach((k) => {
    const s = resolvedStyles[k] ?? {}
    const set = new Set<string>()
    collectDollarRefs(s, set)
    deps[k] = set
  })

  const classes: Record<string, string> = {}
  const done = new Set<string>()

  let progress = true
  let iterations = 0
  const maxIterations = keys.length * 2

  while (progress && iterations++ < maxIterations) {
    progress = false

    for (const k of keys) {
      if (done.has(k)) continue
      const allDepsKnown = Array.from(deps[k]).every((d) => classes[d])

      if (deps[k].size === 0) {
        try {
          classes[k] = css(resolvedStyles[k] || {})
        } catch (e) {
          if (DEV)
            console.error('[makeStyles] Failed to compile style for', k, e)
          classes[k] = css({})
        }
        done.add(k)
        progress = true
      } else if (allDepsKnown) {
        const replaced = replaceDollarRefs(
          resolvedStyles[k] || {},
          (ref) => classes[ref]
        )
        try {
          classes[k] = css(replaced)
        } catch (e) {
          if (DEV)
            console.error(
              '[makeStyles] Failed to compile (with $refs) for',
              k,
              e
            )
          classes[k] = css({})
        }
        done.add(k)
        progress = true
      }
    }
  }

  for (const k of keys) {
    if (done.has(k)) continue
    const replaced = replaceDollarRefs(
      resolvedStyles[k] || {},
      (ref) => classes[ref]
    )
    try {
      classes[k] = css(replaced)
    } catch (e) {
      if (DEV) console.error('[makeStyles] Fallback compile failed for', k, e)
      classes[k] = css({})
    }
    done.add(k)
  }

  return classes
}

/** ✅ Strongly typed makeStyles */
export function makeStyles<
  TProps = any,
  TTheme = Theme,
  TStyles extends Styles<TProps, TTheme> = Styles<TProps, TTheme>,
>(
  styles: (theme: TTheme) => TStyles
): (props?: TProps) => { [K in keyof TStyles]: string } {
  return (props?: TProps) => {
    const theme = useTheme<TTheme>()

    return useMemo(() => {
      let styleMap: TStyles
      try {
        styleMap = styles(theme) || ({} as TStyles)
      } catch (e) {
        if (DEV) console.error('[makeStyles] styles(theme) threw:', e)
        return {} as { [K in keyof TStyles]: string }
      }

      const resolved = {} as Record<keyof TStyles, StyleObject>
      for (const key of Object.keys(styleMap) as (keyof TStyles)[]) {
        const entry = styleMap[key]
        try {
          const style =
            typeof entry === 'function'
              ? (entry as any)(props ?? ({} as TProps), theme)
              : entry
          resolved[key] = isPlainObject(style) ? style : {}
        } catch (e) {
          if (DEV)
            console.error(
              `[makeStyles] style "${String(key)}" resolver threw:`,
              e
            )
          resolved[key] = {}
        }
      }

      try {
        return compileStyles(resolved as Record<string, StyleObject>) as {
          [K in keyof TStyles]: string
        }
      } catch (e) {
        if (DEV) console.error('[makeStyles] compileStyles threw:', e)
        const empty = css({})
        const fallback = {} as { [K in keyof TStyles]: string }
        for (const k of Object.keys(resolved) as (keyof TStyles)[]) {
          fallback[k] = empty
        }
        return fallback
      }
    }, [theme, props])
  }
}

// Version 4

/* This hook is limited some ways to apply styles might not work like mui makestyles */
